<template>
  <div>
    <b-row>
      <b-col lg="4" class="my-1">
          <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
      </b-col>
      <b-col lg="4" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table :filter="filter" @filtered="onFiltered" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="clients" :fields="fields" :current-page="currentPage" :per-page="perPage">
      <template slot="name" slot-scope="data">
        <router-link :to="'/clients/' + data.item.id">{{data.item.name}}</router-link>
      </template>
      <template slot="site_url" slot-scope="data">
        <a :href="data.item.site_url" target='_blank'>{{data.item.site_url}}</a>
      </template>
      <template slot="adworks_client_name" slot-scope="data">
        <a :href="'http://adworks.gosokal.com/clients/' + data.item.adworks_slug" target='_blank'>{{data.item.adworks_client_name}}</a>
      </template>
    </b-table>
    <nav>
      <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Clients',
  data () {
    return {
      currentClientId: null,
      fields: [
        {key: 'id', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'name'},
        {key: 'site_url', label: 'Verified Site Url'},
        {key: 'analytic_account_email'},
        {key: 'adworks_client_name'},
        {key: 'adworks_slug', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'client_group_names'}
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      pageOptions: [5, 10, 25, 50, 100]
    }
  },
  computed: {
    ...mapGetters(['clients'])
  },

  props: {
    caption: {
      type: String,
      default: 'Clients'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    this.totalRows = this.clients.length
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }

}
</script>

<style scoped>
  .card-body {
    margin-top: 0 !important;
  }
  .card .card-header {
    font-family: 'Cooper Hewitt Semibold';
    text-transform: uppercase;
    color: #3493B2;
    letter-spacing: 2px;
  }
</style>
